import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
interface LegalLayoutProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}
export function LegalLayout({
  title,
  lastUpdated,
  children
}: LegalLayoutProps) {
  const {
    t
  } = useLanguage();
  return <div className="py-24 md:py-32 px-6" data-id="element-88">
      <div className="max-w-3xl mx-auto" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-90">
          <h1 className="text-3xl md:text-5xl font-heading font-light tracking-tight mb-6" data-id="element-91">
            {title}
          </h1>
          <div className="w-12 h-px bg-gold mb-8" data-id="element-92"></div>
          <p className="text-sm text-black/50 uppercase tracking-widest mb-16" data-id="element-93">
            {t('legal.common.lastUpdated')}: {lastUpdated}
          </p>
          <div className="prose prose-neutral prose-headings:font-heading prose-headings:font-normal prose-h2:text-xl prose-h2:mt-12 prose-h2:mb-4 prose-p:text-black/70 prose-p:leading-relaxed prose-a:text-gold hover:prose-a:text-gold-dark max-w-none" data-id="element-94">
            {children}
          </div>
        </motion.div>
      </div>
    </div>;
}